function globalStatus(status) {
    let r
    switch (status) {
        case 'Aktif':
            r = '<span class="badge rounded-pill bg-success">Aktif</span>'
            break;
        case 1:
            r = '<span class="badge rounded-pill bg-success">Aktif</span>'
            break;
        case 'Pasif':
            r = '<span class="badge rounded-pill bg-danger">Pasif</span>'
            break;
        case 2:
            r = '<span class="badge rounded-pill bg-danger">Pasif</span>'
            break;
        default:
        r = status
            break;
    }
    return r
}

function ability(roleName) {
    const userdata = JSON.parse(localStorage.getItem('user'))
    if(roleName){
        const noAuth = userdata.abilities ?? [];
        if(noAuth == '*') return true
        return noAuth.includes(roleName)
    }
}
function onlyUserCheck(rolename) {
    const userdata = JSON.parse(localStorage.getItem('user'))
    return userdata?.role_name == rolename
}

function upperCase(input) {
    var harfDegerleri = {
        'i': 'İ',
        'ı': 'I',
        'ğ': 'Ğ',
        'ü': 'Ü',
        'ş': 'Ş',
        'ö': 'Ö',
        'ç': 'Ç',
        'a': 'A',
        'b': 'B',
        'c': 'C',
        'd': 'D',
        'e': 'E',
        'f': 'F',
        'g': 'G',
        'h': 'H',
        'j': 'J',
        'k': 'K',
        'l': 'L',
        'm': 'M',
        'n': 'N',
        'o': 'O',
        'p': 'P',
        'q': 'Q',
        'r': 'R',
        's': 'S',
        't': 'T',
        'u': 'U',
        'v': 'V',
        'w': 'W',
        'x': 'X',
        'y': 'Y',
        'z': 'Z'
    };

    var inputUzunluk = input.length;
    var buyukHarfliMetin = '';

    for (var i = 0; i < inputUzunluk; i++) {
        var harf = input[i];
        var buyukHarf = harfDegerleri[harf.toLowerCase()] || harf;
        buyukHarfliMetin += buyukHarf;
    }

    return buyukHarfliMetin;
}

export {
    globalStatus,
    ability,
    onlyUserCheck,
    upperCase
}
    
